App.filter('relationshipFormatter', function () {
    return function (el) {
        el = el || '';

        var dictionary = [];
        
        dictionary['SPOUSE'] = 'małżonek';
        dictionary['LIFE_PARTNER'] = 'partner życiowy';
        dictionary['CHILD'] = 'dziecko';
        dictionary['PARENT'] = 'rodzic';
        dictionary['SIBLING'] = 'rodzeństwo';
        dictionary['OTHER'] = 'inny';

        if (el) {
        	if (dictionary[el]) {
        		return dictionary[el];
        	} else {
        		return el;
        	}
        }

        return el;
    };
})